import React, { useState } from 'react';
import { SimpleForm, useUpdate, useNotify, useRefresh } from 'react-admin';
import { Box } from '@mui/material';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';

import { Resource } from 'src/constants';
import { ShsButton, ShsSaveButton, ShsDatePicker } from 'src/components/common';
import DateTimeUtils from 'src/utils/datetime';

const styles = {
    display: 'inline-block',
    '&.MuiCardContent-root, &.MuiToolbar-root': {
        display: 'inline-block',
        p: 0,
        m: 0,
        mt: 0.4
    },
    '&.MuiToolbar-root .MuiButtonBase-root': {
        mt: '-2px'
    }
};

const Toolbar: React.FC = () => {
    return (
        <Box sx={styles} className="add-child-toolbar">
            <ShsSaveButton label="Зберегти" sx={{ height: '45px', ml: 2 }} />
        </Box>
    );
};

export const EmploymentEndDate: React.FC<{ index: number }> = ({ index }) => {
    const [newServiceEndDate, setNewServiceEndDate] = useState<boolean>(false);
    const [update] = useUpdate();
    const refresh = useRefresh();
    const notify = useNotify();

    const handleSubmit = async (data: any) => {
        const employeeCenters = data.employeeCenters.map((center: any) => {
            const centerWithFormattedDateOfEnding =
                center.tempIndex === index
                    ? { ...center, dateOfEnding: DateTimeUtils.getFormattedDate(data.dateOfEnding) }
                    : center;
            delete centerWithFormattedDateOfEnding.tempIndex;
            return centerWithFormattedDateOfEnding;
        });
        delete data.dateOfEnding;

        const payload = {
            ...data,
            employeeCenters
        };

        await update(
            Resource.EMPLOYEES,
            {
                id: data.id,
                data: payload,
                meta: { useMock: false, method: `update` }
            },
            {
                mutationMode: 'optimistic',
                onSuccess: () => {
                    setNewServiceEndDate(false);
                    refresh();
                    notify('Дані збережено', { type: 'success', undoable: true });
                },
                onError: (error: any) => {
                    setNewServiceEndDate(false);
                    notify(`Error: ${error?.message}`, { type: 'warning', undoable: true });
                }
            }
        );
    };
    return (
        <>
            {newServiceEndDate ? (
                <SimpleForm sx={styles} toolbar={<Toolbar />} onSubmit={handleSubmit}>
                    <ShsDatePicker source="dateOfEnding" label="" required />
                </SimpleForm>
            ) : (
                <ShsButton
                    styleType="round"
                    label="Додати"
                    icon={<AddCircleOutlineIcon />}
                    sx={{ height: '24px', border: 'none !important', p: '0 !important', mt: '-5px' }}
                    onClick={() => setNewServiceEndDate(true)}
                />
            )}
        </>
    );
};
